"use strict";
	
export default class ChampCommonController
{
	/*@ngInject*/
	constructor($http, $scope, $stateParams,$log)
	{
		//console.log("ChampCommonController");

		$scope.AddClass = function()
		{
			$scope.vm.data.classes.push({});
		};

		$scope.RemoveClass = function(index, value)
		{
			$scope.vm.data.classes.splice(index, 1);
		};

		$scope.AddExtra = function()
		{
			$scope.vm.data.extra.push({name: null, defaultpoints: null, comments: null});
		}

		$scope.RemoveExtra = function(index, value)
		{
			$scope.vm.data.extra.splice(index, 1);
		}

		$scope.CheckExtra = function(value, extra, fieldname)
		{
			if (fieldname === "defaultpoints")
			{
				if (value != null && value != "")
				{
					var i = parseInt(value, 10);
					if (value != i)
						return "El valor por defecto debe ser un número entero o vacío";
				}
			}
		}

		$scope.vm.CollectChampData = function(data)
		{
			var ret = {};
			
			ret.title = data.title;
			
			ret.selectedcategories = [];
			for (var i = 0; i < data.categories.length; ++i)
			{
				if (data.categories[i].selected === true) ret.selectedcategories.push({id:data.categories[i].id, name:data.categories[i].name});
			}
			
			ret.selectedscore = data.selectedscore;

			ret.published = data.published || false;
			ret.extra = data.extra;

			for (var i = 0; i < ret.extra.length; ++i)
			{
				if (ret.extra[i].defaultpoints === "")
					ret.extra[i].defaultpoints = null;
			}

			ret.discards = data.discards;
			
			return ret;
		}
	}
}



// WEBPACK FOOTER //
// ./client/app/backend/champs/champ_common.controller.js